import { Button, Dialog } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

const InvoiceResponsibleConfirmationDialog = ({ isOpen, onClose, onYes, isResponsibleForBilling, parentCount }) => {
  const { t } = useTranslation();

  let message = `billingResponsibleConfirmationDialogIsNotResponsibleDescription`;

  if (isResponsibleForBilling && parentCount <= 1) {
    message = `billingResponsibleConfirmationDialogIsOnlyResponsibleDescription`;
  } else if (isResponsibleForBilling && parentCount >= 2) {
    message = `billingResponsibleConfirmationDialogIsResponsibleDescription`;
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} hasCloseButton={true} fullScreenOnMobile={true}>
      <Dialog.Panel>
        <Dialog.Title data-testid="responsible-for-billing-title">
          {t('students.billing.responsibleTitle')}
        </Dialog.Title>
        <p>{t(message)}</p>
      </Dialog.Panel>
      <Dialog.Actions>
        {isResponsibleForBilling ? (
          <div className="flex w-full flex-col space-y-2">
            <Button
              positive
              label={t('common.continue')}
              style={{ width: '100%' }}
              onClick={() => onClose()}
              data-testid="ok-btn"
            />
          </div>
        ) : (
          <div className="flex w-full flex-col space-y-2">
            <Button
              primary
              label={t('common.continue')}
              onClick={() => onYes()}
              data-testid="responsible-for-billing-btn"
              style={{ width: '100%' }}
            />

            <Button onClick={onClose} data-testid="cancel-btn" label={t('common.cancel')} style={{ width: '100%' }} />
          </div>
        )}
      </Dialog.Actions>
    </Dialog>
  );
};

export default InvoiceResponsibleConfirmationDialog;
